import { useEffect } from 'react';

import { useFlag } from '../services/launchDarkly';
import { useStores } from '../stores/useStores';

// Warm the game-ui origin (DNS + TLS + connection) AND prefetch its document/bundle, so the Crown Rips
// iframe on click doesn't pay connection setup + a cold JS download/parse. Idempotent.
function preconnectGameUi() {
  const href = import.meta.env.VITE_GAME_UI_URL;
  if (!href || document.querySelector(`link[data-crown-rips-warm][href="${href}"]`)) {
    return;
  }
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = href;
  preconnect.crossOrigin = 'anonymous';
  preconnect.setAttribute('data-crown-rips-warm', '');
  document.head.appendChild(preconnect);

  // Prefetch the game-ui document so its module bundle is in cache before the iframe mounts.
  const prefetch = document.createElement('link');
  prefetch.rel = 'prefetch';
  prefetch.as = 'document';
  prefetch.href = href;
  prefetch.crossOrigin = 'anonymous';
  prefetch.setAttribute('data-crown-rips-warm', '');
  document.head.appendChild(prefetch);
}

// Crown Rips kill switch (LD `crown_rips_enabled`). When on: marks the feature enabled (gates the menu
// entry), warms the game-id resolution AND preconnects the game-ui origin at app start, so launching
// from the menu has no extra round-trip / connection latency. Mounted once in the app shell (Layout).
export function useCrownRipsFeature() {
  const { crownRipsStore } = useStores();
  const enabled = useFlag('crown_rips_enabled', false);

  useEffect(() => {
    crownRipsStore.setEnabled(enabled);
    if (enabled) {
      crownRipsStore.prefetchGame();
      void crownRipsStore.fetchPendingPacksCount();
      preconnectGameUi();
    }
  }, [enabled, crownRipsStore]);
}
